import Cache from 'root/cache';

export default function(model) {
    var is_merged_feedback = model.isMergedFeedback();
    var is_design = model.isDesign() || model.isPdf() || model.isVideoUpload();
    var is_following = Cache.feedback_watch_list.findWhere({feedback_id: model.id, user_id: Cache.real_user_id}) ? true : false;
    var portal = Cache.portal.findWhere({project_id: model.get('project_id')});

    return '' +
    '<ul class="dropdown dropdown-long">' +
        '<li class="feedback-share">Share</li>' +
        '<li class="feedback-watch">' + (is_following ? 'Unfollow' : 'Follow') + '</li>' +

        (is_design ? '' :
        (portal && !is_merged_feedback ?
        model.get('is_portal_approved') ?
        '<li class="feedback-publish">Unpublish</li>' :
        '<li class="feedback-publish">Publish</li>' : '') +

        '<li class="feedback-rename">Edit Title</li>' +
        (!is_merged_feedback ?
        '<li class="feedback-merge">Merge Duplicates</li>' : '') +
        (is_merged_feedback ?
        '<li class="feedback-unmerge">Unmerge</li>' : '')
        ) +

        (!is_merged_feedback ?
        '<li class="feedback-move">Move</li>' : '') +

        '<li class="separator"></li>' +
        '<li class="feedback-delete">Delete</li>' +
    '</ul>';
}